export interface RadioGroupChangeEventDetail {
  value: any;
}
